// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VNProcessing_wrapper__2OcdH","loader":"VNProcessing_loader__3gbIc","title":"VNProcessing_title__2ylhK","subtitle":"VNProcessing_subtitle__1Q969"};